import { callApiToServer } from '../callApi';

export async function editCompany(
  authtoken,
  companyObject,
  companyId,
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify(companyObject);
  
    let endUrl = "v1/auth/edit-company";
    console.log("endUrl printed here", endUrl);
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
      
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
